<h1 class="text-center mt-2" id="tag-manager-top-page">Gestion des tags</h1>

<div class="form-add-tag mt-4">
  <h3 id="tag-create-update-title">Ajouter un tag : </h3>
  <form [formGroup]="tagForm" (ngSubmit)="onSubmit()"
        class="d-flex tag-form mr-5">
    <mat-form-field style="width: 400px" class="mr-5 mt-4">
      <mat-label>Nom du tag</mat-label>
      <input matInput [formControl]="tagName">
    </mat-form-field>
    <div class="row">
      <button type="submit" class="btn btn-dark d-flex align-items-center btn-create p-2 ml-4'" id="tag-create-update-btn">
        <mat-icon class="mr-2">add_circle</mat-icon>
        Ajouter le tag
      </button>
      <button (click)="onCancel()" *ngIf="isEditing" class="ml-2 btn btn-outline-dark d-flex align-items-center btn-create p-2 ml-4'" id="tag-cancel-btn">
        Annuler
      </button>
    </div>
  </form>
</div>

<div class="table-tag">
  <div class="mt-4 col-12 text-right d-flex justify-content-end align-items-center">
    <mat-form-field style="width: 250px">
      <mat-label>Recherche</mat-label>
      <input matInput (keyup)="applyFilter($event)">
    </mat-form-field>
  </div>
</div>
<table class="mt-3 table table-striped table-bordered table-tag">
  <thead>
  <th (click)="sortId()" style="width: 100px" class="pointer">ID</th>
  <th (click)="sortName()" class="pointer">Nom</th>
  <th style="width: 50px">Modifier</th>
  <th style="width: 50px">Supprimer</th>
  </thead>
  <tbody>
  <tr *ngFor="let tag of tags.filteredData">
    <td class="text-center">{{tag.id}}</td>
    <td class="text-center">{{tag.nom}}</td>
    <td class="text-center" style="cursor: pointer" (click)="onEdit(tag.id, tag.nom)"><mat-icon>edit</mat-icon></td>
    <td class="text-center" style="cursor: pointer; color: red;" (click)="onDelete(tag.id)"><mat-icon>delete</mat-icon></td>
  </tr>
  </tbody>
</table>
